const EnvManager = Object.freeze(
  {
    AUTH_URL: process.env.REACT_APP_AUTH_SERVICE_BACKEND_URL,
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    SKIP_AUTH: process.env.REACT_APP_SKIP_AUTH === 'True'
  }
);

export default EnvManager;
